/**
 * @generated SignedSource<<80165f667aca376497bc92360fcc8c4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveAsanaProjectItemInput = {
  blockKey: string;
  clientMutationId?: string | null;
  noteId: string;
};
export type AsanaIntegrationRemoveProjectItemMutation$variables = {
  input: RemoveAsanaProjectItemInput;
};
export type AsanaIntegrationRemoveProjectItemMutation$data = {
  readonly removeAsanaProjectItem: {
    readonly deletedAsanaBlockLinkId: string;
  } | null;
};
export type AsanaIntegrationRemoveProjectItemMutation = {
  response: AsanaIntegrationRemoveProjectItemMutation$data;
  variables: AsanaIntegrationRemoveProjectItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveAsanaProjectItemPayload",
    "kind": "LinkedField",
    "name": "removeAsanaProjectItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAsanaBlockLinkId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AsanaIntegrationRemoveProjectItemMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AsanaIntegrationRemoveProjectItemMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "430f192c939e2317ff6452e84b83d58b",
    "id": null,
    "metadata": {},
    "name": "AsanaIntegrationRemoveProjectItemMutation",
    "operationKind": "mutation",
    "text": "mutation AsanaIntegrationRemoveProjectItemMutation(\n  $input: RemoveAsanaProjectItemInput!\n) {\n  removeAsanaProjectItem(input: $input) {\n    deletedAsanaBlockLinkId\n  }\n}\n"
  }
};
})();

(node as any).hash = "379e872ca585712eec82f1c1cfbc995b";

export default node;
